import {
  Appointment,
  AppointmentMetadataFiltersParams,
  PaginatedAppointmentsMetadataResponse,
} from "@/src/models/appointment";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getAppointmentById(id: string): Promise<Appointment | null> {
  return fetchJSON<Appointment | null>(`/api/appointments/${id}`);
}

export async function getPaginatedAppointmentsMetadata(
  params: AppointmentMetadataFiltersParams
): Promise<PaginatedAppointmentsMetadataResponse> {
  const searchParams = new URLSearchParams({
    page: params.page?.toString() ?? "0",
    pageSize: params.pageSize?.toString() ?? "30",
    sortBy: params.sortBy ?? "createdAt",
    sortOrder: params.sortOrder ?? "desc",
  });

  if (params.createdBy) {
    searchParams.set("createdBy", params.createdBy);
  }

  return fetchJSON<PaginatedAppointmentsMetadataResponse>(`/api/appointments?${searchParams.toString()}`);
}

export async function updateAppointmentById(
  id: string,
  updates: Pick<Partial<Appointment>, "ehrId" | "createdBy">
): Promise<Appointment> {
  return fetchJSON<Appointment>(`/api/appointments/${id}`, {
    method: "PATCH",
    body: JSON.stringify(updates),
    headers: { "Content-Type": "application/json" },
  });
}
